import { BeneficioService } from "services/comunicacion-cultura";
import { beneficioSeleccionadoAtom, loadingAtom, openModalRechazarBeneficioAtom } from "../store/store";
import { useAtom } from "jotai";
import useBeneficiosPage from "./useBeneficiosPage";

const useModalRechazarBeneficio = () => {

    const [open, setOpen] = useAtom(openModalRechazarBeneficioAtom);
    const [beneficioSeleccionado, setBeneficioSeleccionado] = useAtom(beneficioSeleccionadoAtom);
    const [loading, setLoading] = useAtom(loadingAtom);
    const { fetchBeneficiosPendientesAprobacion } = useBeneficiosPage();

    const abrirModal = (beneficio) => {
        setBeneficioSeleccionado(beneficio);
        setOpen(true);
    }

    const cerrarModal = () => {
        setBeneficioSeleccionado(undefined);
        setOpen(false);
    }

    const rechazar = async (formInstance) => {
        formInstance
            .validateFields()
            .then(async (payload) => {
                console.log("payload", payload);
                setLoading(true);
                await BeneficioService.rechazar(beneficioSeleccionado.id, payload);
                fetchBeneficiosPendientesAprobacion();
                setLoading(false);
                cerrarModal();
            })
            .catch((info) => {
                console.log('Validate Failed:', info);
                setLoading(false);
            });
    }

    return {
        open,
        loading,
        abrirModal,
        cerrarModal,
        rechazar
    };
};

export default useModalRechazarBeneficio;